<template>
    <v-container :class="isMobile()? '':'pt-3 pl-1'">
        <div style="display:none;">{{resultDisplayTrigger1}}</div>
        <FlightFareBox 
            v-show="isSelected(bx.Airline)&&flightFareRouteMatched(bx)&&totalPriceMatched(bx)" 
            v-for="(bx,index) in modifiedFlightFares" :key="index" 
            :FlightFare="reorderFlightGroups(bx)" 
            :AdultCount="adult" 
            :ChildCount="child" 
            :InfantCount="infant"
            :TotalPrice="getTotalFare(bx)"
            :SearchId="SearchId"/>
    </v-container>
</template>

<script>
import SearchResultList from './SearchResultList.code.js';

export default SearchResultList;
</script>

<style>

</style>
